import {
  normalizeRdoStatus,
  RdoDetalhamentoApi,
  RdoMetricasApi,
  RdoOperacaoClasseApi,
  RdoOperacoesResponse,
  RdoPeriodoSectionVm,
  RdoTableRow,
} from "./rdoOperacoes.types";

function childLabel(
  d: RdoDetalhamentoApi,
  operacaoCalendarizada: boolean
): string {
  if (d.descricao?.trim()) return d.descricao.trim();
  const prefix = operacaoCalendarizada ? "Passada" : "Janela";
  return `${prefix} ${d.sequencia}`;
}

function mapMetricas(m: RdoMetricasApi) {
  return {
    areaPrevista: m.areaPrevista ?? null,
    areaRealizada: m.areaRealizada ?? null,
    areaARealizar: m.areaARealizar ?? null,
    percentualExecucao: m.percentualExecucao ?? null,
    metaDiaria: m.metaDiaria ?? null,
    ritmoDiario: m.ritmoDiario ?? null,
    // Campos opcionais no JSON — ausentes viram null (UI mostra "-")
    metaDiariaAjustada: m.metaDiariaAjustada ?? null,
    dataInicial: m.dataInicial ?? null,
    projecaoTermino: m.projecaoTermino ?? null,
    status: normalizeRdoStatus(m.status),
  };
}

function mapDetalhamento(
  d: RdoDetalhamentoApi,
  operacaoClasseId: string,
  operacaoNome: string,
  operacaoCalendarizadaPai: boolean,
  index: number
): RdoTableRow {
  const operacaoCalendarizada =
    d.operacaoCalendarizada ?? operacaoCalendarizadaPai;
  return {
    // index evita colisão quando duas filhas compartilham a mesma sequencia
    key: `${operacaoClasseId}-det-${d.sequencia}-${index}`,
    isParent: false,
    operacaoClasseId,
    operacaoCalendarizada,
    nome: childLabel(d, operacaoCalendarizada),
    operacaoNome,
    sequencia: d.sequencia ?? null,
    ...mapMetricas(d),
  };
}

function mapClasse(c: RdoOperacaoClasseApi): RdoTableRow {
  const operacaoNome = c.operacaoClasse;
  const detalhamentos = c.detalhamentos?.length
    ? c.detalhamentos
        .slice()
        .sort((a, b) => (a.sequencia ?? 0) - (b.sequencia ?? 0))
        .map((d, index) =>
          mapDetalhamento(
            d,
            c.operacaoClasseId,
            operacaoNome,
            c.operacaoCalendarizada,
            index
          )
        )
    : undefined;

  return {
    key: c.operacaoClasseId,
    isParent: true,
    operacaoClasseId: c.operacaoClasseId,
    operacaoCalendarizada: !!c.operacaoCalendarizada,
    nome: operacaoNome,
    operacaoNome,
    // Classe consolidada não traz sequencia no contrato atual
    sequencia: null,
    ...mapMetricas(c),
    detalhamentos,
  };
}

export function mapRdoOperacoesToSections(
  data?: RdoOperacoesResponse | null
): RdoPeriodoSectionVm[] {
  if (!data?.length) return [];

  return data.map((periodo) => ({
    safraPeriodoId: periodo.safraPeriodoId,
    titulo: periodo.safraPeriodo,
    ocupacao: periodo.ocupacao,
    rows: (periodo.operacaoClasses || []).map(mapClasse),
  }));
}
